import { DropdownButton, DropdownMenu, Flex, Icon, PrimaryButton, QuietButton } from "@nulogy/components";
import React from "react";
import styled, { css } from "styled-components";

const mainButtonStyles = css`
  margin-right: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  width: 90px;
  justify-content: left;
  font-size: 14px;
  height: 24px;
`;

const QuietMainButton = styled(QuietButton)`
  ${mainButtonStyles};
  background-color: ${({ theme }) => theme.colors.whiteGrey};
`;

const PrimaryMainButton = styled(PrimaryButton)`
  ${mainButtonStyles}
`;

const triggerButtonStyles = css`
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  width: 24px;
  margin-left: 1px;
`;

const QuietTriggerButton = styled(QuietButton)`
  ${triggerButtonStyles};
  background-color: ${({ theme }) => theme.colors.whiteGrey};
`;

const PrimaryTriggerButton = styled(PrimaryButton)`
  ${triggerButtonStyles};
`;

export default function SplitButton({ disabled, onChange, options, selectedOption, quiet }) {
  const MainButton = quiet ? QuietMainButton : PrimaryMainButton;
  const TriggerButton = quiet ? QuietTriggerButton : PrimaryTriggerButton;

  return (
    <Flex>
      <MainButton disabled={disabled} onClick={() => onChange(selectedOption)} size="small">
        {options.find((option) => option.value === selectedOption).label}
      </MainButton>
      <DropdownMenu
        disabled={disabled}
        placement="bottom-end"
        trigger={() => (
          <TriggerButton className="spec-split-trigger-button" size="small">
            <Icon icon="downArrow" size="16px" />
          </TriggerButton>
        )}
        width="116px"
      >
        {options.map((option) => (
          <DropdownButton
            key={option.value}
            onClick={() => {
              onChange(option.value);
            }}
          >
            {option.label}
          </DropdownButton>
        ))}
      </DropdownMenu>
    </Flex>
  );
}
